import "./identities.scss";
import { useState } from "react";
import { SearchIcon } from "lucide-react";
import { UserService } from "../../../services/UserService";

import { DataList, DataListColumn, StatusBadge, Alert } from "../../../components/ui";

const Identities = () => {

    const [query, setQuery]     = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);
    const [results, setResults] = useState<Array<any> | null>(null);
    const [error, setError]     = useState<string | null>(null);

    const handleSearch = async () => {
        if (!query.trim()) return;
        setLoading(true);
        setError(null);
        setResults(null);
        try {
            const response = await UserService.searchKyc(query.trim());
            setResults(Array.isArray(response) ? response : [response]);
        } catch {
            setError("Nenhum resultado encontrado.");
            setResults(null);
        } finally {
            setLoading(false);
        }
    };

    const columns: DataListColumn<any>[] = [
        { key: "name",     header: "Nome",       render: (u) => u.name },
        { key: "document", header: "Documento",  render: (u) => <span style={{ opacity: .55 }}>{u.document}</span>, mono: true },
        { key: "email",    header: "Email",      render: (u) => <span style={{ opacity: .55 }}>{u.email}</span> },
        { key: "address",  header: "Endereco",   render: (u) => <span style={{ opacity: .55 }}>{u.address}</span> },
        { key: "kyc",      header: "Status KYC", render: (u) => <StatusBadge status={u.kycStatus} /> },
    ];

    return (
        <div className="identities-wrapper">
            <h1 className="page-title">
                Identidades
                <small>busca de informacoes KYC por nome, documento, email ou endereco.</small>
            </h1>

            <div className="search-form">
                <input
                    type="text"
                    placeholder="Nome, documento, email ou endereco..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                    onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                />
                <button className="btn-pill primary" onClick={handleSearch}>
                    <SearchIcon size={14} /> Buscar
                </button>
            </div>

            {error && <Alert variant="error">{error}</Alert>}

            {(results !== null || loading) && (
                <DataList
                    columns={columns}
                    rows={results ?? []}
                    loading={loading}
                    empty="Nenhum resultado encontrado."
                />
            )}
        </div>
    );
};

export default Identities;
